export const valueFormatter = (number: number) => `${Intl.NumberFormat().format(number).toString()}`;
